import React from 'react';
import { Typography } from '@mui/material';

export default function SectionHeading({ icon, title, blocks }) {
  if (!blocks) {
    return null;
  }
  return (
    <div className="lesson-section-heading">
      <div className="lesson-section-icon">{icon}</div>

      <Typography variant="h3" className="lesson-section-title">{title}</Typography>
    </div>
  );
}
